import { render, staticRenderFns } from "./down-button.vue?vue&type=template&id=a57a4b9e&scoped=true&"
import script from "./down-button.vue?vue&type=script&lang=js&"
export * from "./down-button.vue?vue&type=script&lang=js&"
import style0 from "./down-button.vue?vue&type=style&index=0&id=a57a4b9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a4b9e",
  null
  
)

export default component.exports